/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_Feature_1Inputs */

const en_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support our mission & open-source work`)
};

const id_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukung misi & pekerjaan sumber terbuka kami`)
};

const ms_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sokong misi & kerja sumber terbuka kami`)
};

const ca_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dona suport a la nostra missió i feina de codi obert`)
};

const cs_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpořte naši misi a open-source práci`)
};

const da_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Støt vores mission og open source-arbejde`)
};

const de_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Mission und Open-Source-Arbeit unterstützen`)
};

const et_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toeta meie missiooni ja avatud lähtekoodiga tööd`)
};

const es_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoya nuestra misión y trabajo de código abierto`)
};

const fr_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutenir notre mission et notre travail open source`)
};

const hr_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podržite našu misiju i rad otvorenog koda`)
};

const it_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostieni la nostra missione e il nostro lavoro open source`)
};

const lv_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbalstiet mūsu misiju un atvērtā koda darbu`)
};

const lt_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palaikykite mūsų misiją ir atvirojo kodo darbą`)
};

const hu_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Támogasd küldetésünket és nyílt forráskódú munkánkat`)
};

const nl_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steun onze missie en open-source werk`)
};

const nb_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Støtt vårt oppdrag og åpen kildekode-arbeid`)
};

const pl_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wspieraj naszą misję i pracę nad otwartym oprogramowaniem`)
};

const pt_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoie nossa missão e o trabalho de código aberto`)
};

const ro_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susține misiunea noastră și munca open-source`)
};

const sk_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podporte našu misiu a prácu na open-source`)
};

const sl_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podprite naše poslanstvo in odprtokodno delo`)
};

const fi_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tue tehtäväämme ja avoimen lähdekoodin työtämme`)
};

const sv_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stöd vårt uppdrag och arbete med öppen källkod`)
};

const vi_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỗ trợ sứ mệnh và công việc mã nguồn mở của chúng tôi`)
};

const tr_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misyonumuzu ve açık kaynak çalışmalarımızı destekleyin`)
};

const el_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Υποστηρίξτε την αποστολή μας & το έργο ανοιχτού κώδικα`)
};

const bg_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подкрепете нашата мисия и работа с отворен код`)
};

const ru_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержите нашу миссию и работу с открытым исходным кодом`)
};

const sr_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подржите našu мисију и open-source рад`)
};

const uk_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтримайте нашу місію та роботу з відкритим кодом`)
};

const ka_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მხარი დაუჭირეთ ჩვენს მისიას და ღია კოდის სამუშაოს`)
};

const hi_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे मिशन और ओपन-सोर्स कार्य का समर्थन करें`)
};

const th_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนับสนุนภารกิจและงานโอเพ่นซอร์สของเรา`)
};

const ko_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`우리의 미션 및 오픈 소스 작업 지원`)
};

const zh_tw_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持我們的使命與開源工作`)
};

const ja_origin_feature_1 = /** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちのミッションとオープンソースの取り組みをサポート`)
};

/** @type {(inputs: Origin_Feature_1Inputs) => LocalizedString} */
const zh_origin_feature_1 = en_origin_feature_1;

/**
* | output |
* | --- |
* | "Support our mission & open-source work" |
*
* @param {Origin_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const origin_feature_1 = /** @type {((inputs?: Origin_Feature_1Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_Feature_1Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_origin_feature_1(inputs)
	if (locale === "ms") return ms_origin_feature_1(inputs)
	if (locale === "ca") return ca_origin_feature_1(inputs)
	if (locale === "cs") return cs_origin_feature_1(inputs)
	if (locale === "da") return da_origin_feature_1(inputs)
	if (locale === "de") return de_origin_feature_1(inputs)
	if (locale === "et") return et_origin_feature_1(inputs)
	if (locale === "es") return es_origin_feature_1(inputs)
	if (locale === "fr") return fr_origin_feature_1(inputs)
	if (locale === "hr") return hr_origin_feature_1(inputs)
	if (locale === "it") return it_origin_feature_1(inputs)
	if (locale === "lv") return lv_origin_feature_1(inputs)
	if (locale === "lt") return lt_origin_feature_1(inputs)
	if (locale === "hu") return hu_origin_feature_1(inputs)
	if (locale === "nl") return nl_origin_feature_1(inputs)
	if (locale === "nb") return nb_origin_feature_1(inputs)
	if (locale === "pl") return pl_origin_feature_1(inputs)
	if (locale === "pt") return pt_origin_feature_1(inputs)
	if (locale === "ro") return ro_origin_feature_1(inputs)
	if (locale === "sk") return sk_origin_feature_1(inputs)
	if (locale === "sl") return sl_origin_feature_1(inputs)
	if (locale === "fi") return fi_origin_feature_1(inputs)
	if (locale === "sv") return sv_origin_feature_1(inputs)
	if (locale === "vi") return vi_origin_feature_1(inputs)
	if (locale === "tr") return tr_origin_feature_1(inputs)
	if (locale === "el") return el_origin_feature_1(inputs)
	if (locale === "bg") return bg_origin_feature_1(inputs)
	if (locale === "ru") return ru_origin_feature_1(inputs)
	if (locale === "sr") return sr_origin_feature_1(inputs)
	if (locale === "uk") return uk_origin_feature_1(inputs)
	if (locale === "ka") return ka_origin_feature_1(inputs)
	if (locale === "hi") return hi_origin_feature_1(inputs)
	if (locale === "th") return th_origin_feature_1(inputs)
	if (locale === "ko") return ko_origin_feature_1(inputs)
	if (locale === "zh") return zh_origin_feature_1(inputs)
	if (locale === "zh-tw") return zh_tw_origin_feature_1(inputs)
	if (locale === "ja") return ja_origin_feature_1(inputs)
	return en_origin_feature_1(inputs)
});